/* eslint-disable @trello/export-matches-filename */

import { TrelloStorage } from '@trello/storage';
import { featureFlagClient } from '@trello/feature-flag-client';

function storageKey(idOrg: string) {
  return `bc_survey_${idOrg}`;
}

function isSurveyEnabled() {
  return featureFlagClient.get('remarkable.bc-survey', false);
}

export function isSurveyVisible(idOrg: string) {
  if (!isSurveyEnabled()) {
    return false;
  }

  const isoDate = TrelloStorage.get(storageKey(idOrg));
  const dateExpires = isoDate && new Date(isoDate);
  const now = new Date();

  return dateExpires && now < dateExpires;
}

export function showSurvey(idOrg: string) {
  if (!isSurveyEnabled()) {
    return false;
  }

  TrelloStorage.set(
    storageKey(idOrg),
    new Date(Date.now() + 10 * 60 * 1000).toISOString(),
  );
}

export function dismissSurvey(idOrg: string) {
  TrelloStorage.unset(storageKey(idOrg));
}
